import { Component, Output, EventEmitter, Inject, ViewChild } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { EventService } from 'src/app/core/services/event.service';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { notification } from './data';
import { RootReducerState } from 'src/app/store';
import { Store } from '@ngrx/store';
import { changeMode } from 'src/app/store/layouts/layout-action';
import { getLayoutmode } from 'src/app/store/layouts/layout-selector';
import { UsersApiService } from '@app/core/api/services/users-api.service';
import {MsalService} from "@azure/msal-angular";



@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent {

  country: any;
  selectedItem!: any;

  flagvalue: any;
  valueset: any;
  countryName: any;
  cookieValue: any;
  userData: any;
  cartData: any;
  element: any;
  mode: string | undefined;

  @Output() mobileMenuButtonClicked = new EventEmitter();

  constructor(
    @Inject(DOCUMENT) private document: any,
    private authService: MsalService,
    private eventService: EventService,
    private router: Router,
    public _cookiesService: CookieService,
    public store: Store<RootReducerState>,
    private usersApiService: UsersApiService
  ){}

  ngOnInit(): void {
    this.element = document.documentElement;
    this.getUserData();
  }

  async getUserData() {
    this.userData = await this.usersApiService.GetCurrentUser({}).toPromise();
  }

  windowScroll() {
    if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
      (document.getElementById('back-to-top') as HTMLElement).style.display = "block";
      document.getElementById('page-topbar')?.classList.add('topbar-shadow')
    } else {
      (document.getElementById('back-to-top') as HTMLElement).style.display = "none";
      document.getElementById('page-topbar')?.classList.remove('topbar-shadow')
    }
  }


  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    document.querySelector('.hamburger-icon')?.classList.toggle('open')
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  /**
   * Logout the user
   */
  logout() {
    // Clear your application-specific data
    // localStorage.clear();
    // sessionStorage.clear();

    // Perform MSAL logout
    this.authService.logoutRedirect({
      postLogoutRedirectUri: '/auth/logout',
    });
  }
}
